module.exports = __webpack_public_path__ + "static/mindwise-d36ba591b6647c069debdd48804d98a0.jpg";